<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack">
						<i class="fa fa-arrow-right"></i>
					</button>
					تهیه اشتراک کاربری
					<button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage">
					<i class="font-16 fa fa-redo"></i>
				</button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>
			<!--<div class="card card-style text-center landingPage-titleDiv mb-2">
				<div class="content">
					<h4 class="mb-3 font-16 text-center">عنوان شرکت: <b class="font-20">{{ taskOnlineItem.companyTitle }}</b></h4>
				</div>
			</div>-->

			<div class="card card-style mb-2">
				<div class="content mt-2">
					<h4 v-if="payable!=orginalpayable && loading==false" class="my-2 font-16 text-center">مبلغ اشتراک: <del class="text-danger font-20">{{orginalpayable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</del></h4>
					<h4 v-if="payable!=orginalpayable && loading==false" class="my-2 font-16 text-center">قابل پرداخت: <b class="font-20">{{payable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</b></h4>
					<h4 v-if="payable===orginalpayable && loading==false" class="my-2 font-16 text-center">قابل پرداخت: <b class="font-20">{{payable.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</b></h4>
					<div class="mb-2 priceDesc-box" v-html="descriptionText"></div>
					<h4 v-if="loading==true" class="text-danger my-2 font-16 text-center">
						<span class="d-flex justify-content-center w-100"><span class="spinner-border color-magenta2-dark" role="status"></span></span>
						<b class="font-16"></b>
					</h4>
					<div class="form-group form-check mb-1">
						<input type="checkbox" id="selectAll" checked @click="onClickSelectAll()" class="form-check-input">
						<label class="form-check-label mx-4" for="exampleCheck1">انتخاب همه</label>
					</div>
					<div class="row mb-0">
						<div class="col-6 pl-1">
							<button :disabled="payable === 0 || loading==true" class="btn btn-m mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click="sendForPayment">
								<i class="fa fa-credit-card ml-2"></i>
								پرداخت
							</button>
							<!--<button v-if="!(payable === 0 || loading==true)" class="btn btn-m mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click="sendForPayment">
				<i class="fa fa-credit-card ml-2"></i>
				پرداخت
			</button>-->
						</div>
						<div class="col-6 pr-1">
							<span class="btn btn-m mt-2 btn-full bg-green2-light rounded-sm font-900 w-100 optionMenu" data-menu="menu-language2">
								<i class="fa fa-user-plus ml-2"></i>
								افزودن کاربر
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="userList-box-OrderPage">
				<div class="card card-style mb-2" v-for="user in taskOnlineItem.usersList" :key="user.id" :class="{ 'bg-fade-gray1-dark': user.selected === false }">
					<div class="list-group list-custom-small list-icon-0">
						<div class="list-group-div p-1 d-flex" :class="{ 'text-muted': user.selected === false }">
							<div class="text-center" style="width: 45px;margin-top:12px">
								<input class="big-checkbox" type="checkbox" :disabled="user.disabled" :id="'pa-' + user.id" @click="onClickPlanAssignBox(user)" :checked="user.selected" />
							</div>
							<div class="d-block w-100">
								<div class="py-2 border-b">
									<i class="fa fa-user-shield color-magenta2-dark font-18" v-if="user.adminOrUser === true"></i>
									<i class="fa fa-user color-yellow1-dark font-18" v-if="user.adminOrUser === false"></i>
									<span v-if="user.registByEmail==true" class="font-weight-bold"> {{ user.userTitle }} - {{ user.emailAddress }}</span>
									<span v-else class="font-weight-bold">{{ user.seq }} - {{ user.userTitle }} - {{ user.phoneNumber }}</span>
									<span @click.stop="showMenu(user.id,user.registByEmail)" width="60px">
										<i class="fa fa-ellipsis-v float-left ml-0 font-14"></i>
									</span>
								</div>
								<div class="py-2 border-b" v-if="user.expireDate != null && user.expireDate != ''">
									<i class="fa fa-times color-red2-dark font-18"></i>
									<span class="font-weight-bold">
										تاریخ انقضای فعلی:
										<span class="d-inline-block ltr text-left mr-2">{{user.expireDate}}</span>
										<span v-if="user.disabled==true" class="d-inline-block rtl mr-2">اشتراک این کاربر بیشتر از تاریخ اعتبار است و امکان تمدید اشتراک برای آن وجود ندارد.</span>
									</span>
								</div>
								<div class="pt-2">
									<!--<i class="fa fa-calendar color-green2-dark font-18"></i>-->
									<!--<span class="font-weight-bold">تعداد ماه:</span>-->
									<!--<span class="mr-3 d-inline-block">
										<button :disabled="loading" type="button" class="btn btn-link p-0" @click="changeMonth(-1, user)">
											<i class="fa font-14 fa-minus bg-green1-dark color-white rounded-sm ml-0 opacity-1"></i>
										</button>
										<span class="font-weight-bold text-center d-inline-block" style="width: 50px">{{ user.monthCount - user.payedMonthCount }}</span>

										<button :disabled="loading" type="button" class="btn btn-link p-0" @click="changeMonth(1, user)">
											<i class="fa font-14 fa-plus bg-green1-dark color-white rounded-sm ml-0 opacity-1"></i>
										</button>
									</span>-->
									<div class="row mb-0 pr-3">
										<div class="col-4 d-flex align-items-center py-2 pr-0 pl-1">
											<input :disabled="!user.selected" class="m-0" type="radio" @change="changeMonthRadio(1, user)" :name="user.id" :id="user.id" value="1" :checked="user.unPayedMonthCount==1" style="width:20%;height:1.8em">
											<label class="mb-0 mr-2 font-14" :for="user.id">
												1 ماه
											</label>
										</div>
										<div class="col-4 d-flex align-items-center py-2 pr-0 pl-1" v-if="user.validMonthCount>=6">
											<input :disabled="!user.selected" class="m-0" type="radio" @change="changeMonthRadio(6, user)" :name="user.id" :id="user.id" value="6" :checked="user.unPayedMonthCount==6" style="width:20%;height:1.8em">
											<label class="mb-0 mr-2 font-14" :for="user.id">
												6 ماه
											</label>
										</div>
										<div class="col-4 d-flex align-items-center py-2 pr-0 pl-1" v-if="user.validMonthCount==12">
											<input :disabled="!user.selected" class="m-0" type="radio" @change="changeMonthRadio(12, user)" :name="user.id" :id="user.id" value="12" :checked="user.unPayedMonthCount==12" style="width:20%;height:1.8em">
											<label class="mb-0 mr-2 font-14" :for="user.id">
												12 ماه
											</label>
										</div>
									</div>
									<!--<div class="row mb-0 pr-3">-->
									<!--<div class="col-6 d-flex align-items-center py-2 pr-0 pl-1" v-if="user.validMonthCount>=3">
										<input :disabled="!user.selected" class="m-0" type="radio" @change="changeMonthRadio(3, user)" :name="user.id" :id="user.id" value="3" :checked="user.unPayedMonthCount==3" style="width:20%;height:1.8em">
										<label class="mb-0 mr-2 font-14" :for="user.id">
											3 ماه
										</label>
									</div>-->
									<!--</div>-->
								</div>
								<!--<div class="py-2">
											<i class="fa fa-check color-green2-dark"></i>
											<span class="font-weight-bold">قابل پرداخت: {{ user.unPayedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} تومان</span>
											<span @click.stop="showMenu(user.id)" width="60px"><i class="fa fa-ellipsis-v float-left ml-0 font-14"></i></span>
								</div>-->
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card card-style" v-if="Loading">
				<div class="content">
					<div class="d-flex justify-content-center w-100">
						<div class="spinner-border color-magenta2-dark" role="status"></div>
					</div>
				</div>
			</div>

		</div>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'CreateUser', params: { id: selectedId, registByEmail:selectedRegist } }" class="d-flex justify-content-between align-items-center">
						<span>
							<i class="fa fa-search color-green2-light float-right font-14"></i>ویرایش
						</span>
						<i class="fa fa-angle-left"></i>
					</router-link>
					<button @click="deleteTaskOnlineUser" class="d-flex justify-content-between align-items-center">
						<span>
							<i class="fa fa-trash color-red1-light float-right font-14"></i>حذف
						</span>
						<i class="fa fa-angle-left"></i>
					</button>
				</div>
				<div class="clear"></div>
			</div>
		</div>

		<div id="menu-language2" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'CreateUser', params: {id:0, registByEmail: true } }" class="d-flex justify-content-between align-items-center">
						<span>
							<i class="fa fa-search color-green2-light float-right font-14"></i>ثبت کاربر جدید با آدرس ایمیل
						</span>
						<i class="fa fa-angle-left"></i>
					</router-link>
					<router-link :to="{ name: 'CreateUser', params: { id:0,registByEmail: false } }" class="d-flex justify-content-between align-items-center">
						<span>
							<i class="fa fa-search color-green2-light float-right font-14"></i>ثبت کاربر جدید با شماره تلفن همراه
						</span>
						<i class="fa fa-angle-left"></i>
					</router-link>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
	</div>
</template>


<script>
	import { Browser } from "@capacitor/browser";
	import VueSimpleAlert from "vue3-simple-alert";
	import { InAppPurchase } from "@ionic-native/in-app-purchase";
	import HelpMenu from '../Components/HelpMenu.vue';
	import User from "../../store/Modules/User";
	export default {
		components: {
			"Help-Menu": HelpMenu
		},
		data() {
			return {
				taskOnlineItem: {
					companyTitle: "",
					adminCode: "",
					adminKeyEn: "",
					usersList: [],
				},
				userIdList: [],
				searchKey: "",
                taskOnlinePayForFreeMessage: "",
				isLoad: true,
				Description: "",
				selectedId: 0,
				selectedRegist: false,
				pageLoaded: false,
				pageLoading: true,
				loading: false,
				modifiedCheck: false,
				PriceRate: 70000,
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			orginalpayable() {
				var sum1 = this.taskOnlineItem.usersList
					.filter((x) => x.selected == true)
					.reduce((a, b) => +a + +(b.monthCount - b.payedMonthCount), 0);
				var res1 = sum1 * 1.10 * this.PriceRate;
				return res1.toFixed();
			},
			payable() {

				var sum = this.taskOnlineItem.usersList
					.filter((x) => x.selected == true)
					.reduce((a, b) => +a + +b.unPayedPrice, 0);
				var res = sum * 1.10;
				return res.toFixed();
			},
			descriptionText() {
				return this.Description;
			},
		},

		created() {
			this.GetPriceRate();
			this.GetTaskOnlineItem();
			this.$http
				.get("TaskOnline/GetTaskOnlineMessage")
				.then((data) => {
					this.Description = data.data.description;
				});
			this.$http
                .get("TaskOnline/GetTaskOnlinePayForFreeMessage")
				.then((data) => {
                    this.taskOnlinePayForFreeMessage = data.data;
				});
		},

		methods: {
			showMenu(id, registVal) {
				this.selectedId = id;
				this.selectedRegist = registVal;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			deleteTaskOnlineUser() {
				VueSimpleAlert.confirm(
					"آیا مایل به حذف این کاربر هستید؟",
					null,
					"question",
					{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
				).then(() => {
					this.$http
						.get("TaskOnline/Delete?id=" + this.selectedId)
						.then((data) => {
							var res = data.data.toString();
							if (res == "1") {
								this.showSuccessMessage("با موفقیت حذف شد.");
								document.getElementsByClassName("menu-hider")[0].click();
								this.GetTaskOnlineItem();
							} else {
								this.showErrorMessage(res);
							}
						});
				});
			},
			openDetails(id) {
				this.$router.push({ name: "CreateUser", params: { id: id } });
				document.getElementsByClassName("menu-hider")[0].click();
			},
			changeMonth(val, user) {

				//if (val === 1) {
				//    if ((user.monthCount % 3) == 0 || (user.monthCount % 3) == 1) {
				//        if (user.monthCount > 1) {
				//            val = 3
				//        } else {
				//            val = 2
				//        }
				//    } else {
				//        val = 1
				//    }
				//} else {
				//    if ((user.monthCount + val) > 1)
				//        val = -3
				//    if ((user.monthCount + val) < 1)
				//        val = -2
				//}

				//var c = user.monthCount + val;
				//var relVal = (user.monthCount - user.payedMonthCount + val);


				var c = user.monthCount + val;
				var relVal = (user.monthCount - user.payedMonthCount + val);
				if (user.payedMonthCount <= c) {
					this.loading = true;
					user.monthCount = c;
					this.$http
						.get("TaskOnline/ChangeMonthCount?id=" + user.id + "&val=" + c + "&relVal=" + relVal)
						.then((data) => {
							this.loading = false;
							if (data.data == "1") {
								this.GetTaskOnlineItem();
							} else {
								this.showErrorMessage(data.data);
							}
						});
				}
			},

			changeMonthRadio(val, user) {
				var oldVal = user.monthCount - user.payedMonthCount;
				var c = user.monthCount + (val - oldVal);//تعداد ماهی که داره و تعداد ماهی که قراره بهش اضافه بشه
				var relVal = val - oldVal;//تعداد ماهی که قرارا اضافه بشه
				if (user.payedMonthCount <= c && user.selected) {
					this.loading = true;
					this.pageLoading = true;
					user.monthCount = c;
					this.$http
						.get("TaskOnline/ChangeMonthCount?id=" + user.id + "&val=" + c + "&relVal=" + relVal + "&selectVal=" + val)
						.then((data) => {
							this.loading = false;
							this.pageLoading = false;
							if (data.data == "1") {
								this.GetTaskOnlineItem();
							} else {
								this.showErrorMessage(data.data);
							}

						});
				}
			},

			onClickPlanAssignBox(user) {

				user.selected = !user.selected;
				this.modifiedCheck = true;
				var users = this.taskOnlineItem.usersList.filter(function (el) {
					return el.selected == true;
				});
				this.userIdList = users.map((a) => a.id);
			},
			onClickSelectAll() {
				this.taskOnlineItem.usersList.forEach((element) => {
					if (document.getElementById("selectAll").checked) {
						if (!element.disabled) {
							document.getElementById("pa-" + element.id).checked = true;
							element.selected = true;
						}
					} else {
						element.selected = false;
						document.getElementById("pa-" + element.id).checked = false;

					}
				});
			},
			async sendForPayment() {
                if (this.isFreeVersion) {
                    if (this.taskOnlinePayForFreeMessage != null && this.taskOnlinePayForFreeMessage != "") {
                        this.showErrorMessage(this.taskOnlinePayForFreeMessage);
                        return;
                    }
				}    
				if (this.payable === 0 || this.payable === "0") {
					return;
				}
				var users = this.taskOnlineItem.usersList.filter(function (el) {
					return el.selected == true;
				});
				this.userIdList = users.map((a) => a.id);
				console.log(this.userIdList.join(","));

				var adminPhone = this.taskOnlineItem.usersList.filter(
					(x) => x.adminOrUser == true
				)[0].phoneNumber;

				var adminEmail = this.taskOnlineItem.usersList.filter(
					(x) => x.adminOrUser == true
				)[0].emailAddress;
				await Browser.open({
					url:
						"https://dssnovinit.com/dashboard/BankConnection/TaskOnlinePaymentBykey?k=" +
						this.taskOnlineItem.adminKeyEn +
						"&userIdStr=" +
						this.userIdList.join(",") +
						"&pn=" + adminPhone + "&e=" + adminEmail,
				});
			},
			async sendForPaymentBazaar() {
				InAppPurchase.buy("test-plan")
					.then((data) => {
						console.log(data);
						// {
						//   transactionId: ...
						//   receipt: ...
						//   signature: ...
						// }
					})
					.catch((err) => {
						console.log(err);
					});
			},
			GetPriceRate() {
				this.loading = true;
				this.$http.get("TaskOnline/GetPriceRate").then((data) => {
					this.loading = false;
					this.PriceRate = data.data;
				});
			},
			CalcMonthCount(users) {
				if (users == null || users.length == 0) {
					this.pageLoading = false;
					return;
				}
				this.pageLoading = true;
				this.$http.post("TaskOnline/ChangeMonthCountAll", users)
					.then(data => {
						this.pageLoading = false;
						this.GetTaskOnlineItem();
					});
				//this.$http
				//    .get("TaskOnline/ChangeMonthCountAll?id=" + users[i].id + "&val=" + c + "&relVal=" + relVal + "&selectVal=" + val)
				//    .then((data) => {
				//        this.pageLoading = false;
				//    });
				//let oldVal = 0;
				//let c = 0;
				//let relVal = 0;
				//let val = 0;
				//for (var i = 0; i < users.length; i++) {
				//    val = users[i].unPayedMonthCount;
				//    oldVal = users[i].monthCount - users[i].payedMonthCount;
				//    c = users[i].monthCount + (val - oldVal);//تعداد ماهی که داره و تعداد ماهی که قراره بهش اضافه بشه
				//    relVal = val - oldVal;//تعداد ماهی که قرارا اضافه بشه
				//    if (users[i].payedMonthCount <= c) {
				//        users[i].monthCount = c;
				//        this.pageLoading = true;
				//        this.$http
				//            .get("TaskOnline/ChangeMonthCount?id=" + users[i].id + "&val=" + c + "&relVal=" + relVal + "&selectVal=" + val)
				//            .then((data) => {
				//                this.pageLoading = false;
				//            });
				//    }
				//}
			},
			GetTaskOnlineItem() {
				this.loading = true;
				this.$http.get("TaskOnline/GetByUserCode").then((data) => {
					this.taskOnlineItem = data.data;
					if (this.modifiedCheck === true) {
						this.taskOnlineItem.usersList.forEach((element) => {
							if (this.userIdList.includes(element.id)) {
								element.selected = true;
							} else {
								element.selected = false;
							}

						});

					}
					if (this.isLoad) {
						this.isLoad = false;
						this.CalcMonthCount(this.taskOnlineItem.usersList);
					}
					this.loading = false;
				});
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
			console.log("mounted");
		},
	};
</script>
